import {Base} from "@/api/Base"

export class AdvisorAdd extends Base {
    path = "advisor/add"
}